import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import createStore from '../../../store/index';
import sessionPropTypes from '../../../states/session/propTypes';
import envConfigPropTypes from '../../../states/envConfig/propTypes';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import { getFavouriteAccounts } from '../../../states/favourites/actions';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = { isBootStrapInProgress: true };
		const { session, envConfig, user, layoutType } = this.props;
		this.store = createStore({
			session,
			envConfig,
			user,
			accountPaging: {
				layoutType,
			},
		});
	}
	componentDidMount() {
		const { session, handleRoute } = this.props;
		const { dispatch } = this.store;
		Promise.all([dispatch(getFavouriteAccounts(session.bankId))]).then((responses) => {
			if (responses.some((response) => response.error)) {
				handleRoute('WEB-ERROR');
			}
			this.setState({ isBootStrapInProgress: false });
		});
	}

	render() {
		const { envConfig, onSelectAccount, layoutType } = this.props;
		const { isBootStrapInProgress } = this.state;
		return (
			<Provider store={this.store}>
				<div className="web-ui-components">
					<WebUIThemeProvider brandID={envConfig.brandId}>
						<LayoutContainer
							isBootStrapInProgress={isBootStrapInProgress}
							onSelectAccount={onSelectAccount}
							layoutType={layoutType}
						/>
					</WebUIThemeProvider>
				</div>
			</Provider>
		);
	}
}

App.propTypes = {
	session: PropTypes.shape(sessionPropTypes).isRequired,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	user: PropTypes.shape({ id: PropTypes.string }),
	onSelectAccount: PropTypes.func.isRequired,
	layoutType: PropTypes.string.isRequired,
	handleRoute: PropTypes.func.isRequired,
};

export default App;
